import { render } from "./StoryCard.vue?vue&type=template&id=3ae847f8"
import script from "./StoryCard.vue?vue&type=script&lang=js"
export * from "./StoryCard.vue?vue&type=script&lang=js"

import "./StoryCard.vue?vue&type=style&index=0&id=3ae847f8&lang=css"
script.render = render

export default script